// extracted by mini-css-extract-plugin
export default {"logo":"ThingsLogo_logo__lQ-Yy"};